import { render, staticRenderFns } from "./manage-gen-videos.vue?vue&type=template&id=cdc6f8ca&scoped=true&"
import script from "./manage-gen-videos.vue?vue&type=script&lang=js&"
export * from "./manage-gen-videos.vue?vue&type=script&lang=js&"
import style0 from "./manage-gen-videos.vue?vue&type=style&index=0&id=cdc6f8ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc6f8ca",
  null
  
)

export default component.exports